import { render, staticRenderFns } from "./Occurrence.vue?vue&type=template&id=4140696e&scoped=true"
import script from "./Occurrence.vue?vue&type=script&lang=js"
export * from "./Occurrence.vue?vue&type=script&lang=js"
import style0 from "./Occurrence.vue?vue&type=style&index=0&id=4140696e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4140696e",
  null
  
)

export default component.exports